<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view />
    <!-- </keep-alive> -->
  </div>
</template>
<script>
import { isApp } from '@/utils/index';

export default {
  mounted() {
    const outerWidth = window.screen.width;
    console.log(outerWidth);
    if (outerWidth > 1500 && isApp()) {
      document.getElementById('view').setAttribute('content', 'width=1200, initial-scale=1.3, user-scalable=yes');
    }
  },
};
</script>
<style lang="scss">
@import "~@/styles/reset";
@import "~@/styles/global";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
  height: 100%;
}
@media screen and (max-width: 1200px) {
  #app {
    .detail {
      width: 90%;
    }
    .preview-container .preview-detail .preview-left {
      width: 36%;
      min-width: 200px;
      padding: 10px;
      .preview-list {
        width: 100%;
        .preview-item {
          box-sizing: border-box;
          max-width: 100%;
        }
      }
    }
    .preview-container .preview-detail .preview-right {
      width: auto;
      flex: 1;
    }
  }
}
</style>
